import { PackagegoodsApi } from 'src/lib/repository/packagegoods/packagegoods.api';
import type { SharedTableColumn } from '../../common/components/shared-table/shared-table.component';
import {
  PackagegoodsKey,
  PackagegoodsSearchField,
  PackagegoodsTypeConfig,
} from './packagegoods.types';

/**
 * 공통 검색 필드 (4개 타입 모두 동일)
 */
const COMMON_SEARCH_FIELDS: PackagegoodsSearchField[] = [
  {
    name: 'title',
    type: 'text',
    label: 'REPO.TABLE.packagegoods.title',
  },
  {
    name: 'startName',
    type: 'codemaster',
    codemasterType: 'TourRegionCode',
    label: 'Departure Start Point',
  },
  {
    name: 'tourNational',
    type: 'codemaster',
    codemasterType: 'TourNational',
    label: 'brand.travelCountry',
  },
  {
    name: 'tourRegionCode',
    type: 'codemaster',
    codemasterType: 'TourRegionCode',
    label: 'brand.travelArea',
  },
];

/**
 * 기본 컬럼 (car/guide)
 */
const BASE_COLUMNS: SharedTableColumn[] = [
  { key: 'sort', name: 'common.sortNumber', type: 'number', sortable: true },
  { key: 'agentName', name: 'Agent', type: 'text' },
  {
    key: 'tourNational',
    name: 'brand.travelCountry',
    width: '80px',
    type: 'text',
  },
  {
    key: 'tourRegionCode',
    name: 'brand.travelArea',
    width: '80px',
    type: 'text',
  },
  {
    key: 'title',
    name: 'REPO.TABLE.packagegoods.title',
    width: '50%',
    type: 'text',
  },
  {
    key: 'useFlg',
    name: 'useFlg',
    type: 'badge',
    width: '15%',
    valueFn: (item: any): string => (item.useFlg ? 'ON' : 'OFF'),
    badgeClassFn: (item: any): string =>
      item.useFlg ? 'bg-success' : 'bg-secondary',
  },
];

/**
 * 전체 컬럼 (packagegoods/requests)
 */
const FULL_COLUMNS: SharedTableColumn[] = [...BASE_COLUMNS];

/**
 * Packagegoods Config Record (Board 패턴 동일)
 *
 * 4개 타입 (packagegoods, car, guide, requests)을 Config-Driven으로 통합
 */
export const PACKAGEGOODS_CONFIGS: Record<
  PackagegoodsKey,
  PackagegoodsTypeConfig
> = {
  packagegoods: {
    title: 'packageGoods',
    apiClass: PackagegoodsApi,
    routePath: 'master/packagegoods',
    tabs: [
      'basic',
      'introContent',
      'noticePolicy',
      'schedule',
      'price',
      'layout',
      'system',
    ],
    hasCopy: true,
    hasDeleteSystem: true,
    hasBatchInsert: true,
    cachePrefix: '/packagegoods',
    hmpgPath: 'package',
    columns: FULL_COLUMNS,
    searchFields: COMMON_SEARCH_FIELDS,
    viewType: 'table',
    defaultSort: 'sort,asc',
    defaultPageSize: 10,
    permissions: ['PACKAGEGOODS$READ'],
  },
};
